import {Text, View} from "react-native";
import {styles} from "./styles";
import DropdownIcon from "../icons/DropdownIcon";
import React from "react";

export const FormItemContainer = (props) => {
    return (
        <View style={styles.restaurant.formItemContainer}>
            {props.children}
            <Text style={styles.restaurant.formItemTitle}>{props.title}</Text>
            <DropdownIcon style={styles.restaurant.dropdownIcon} />
        </View>
    )
}
